import '.by{flex-shrink:0;}.ssr-plugin'
import '.bz{padding:1rem;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.bp{height:100%;}.ssr-plugin'
import '.b1{border:none;}.ssr-plugin'
import '.b2{background-color:transparent;}.ssr-plugin'
import '.ga{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.ct{position:sticky;}.ssr-plugin'
import '.gb{top:4rem;}.ssr-plugin'
import '.gc{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.gd{padding-bottom:1rem;}.ssr-plugin'
import '.o{margin-bottom:1rem;}.ssr-plugin'
import '.ge{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a5{position:fixed;}.ssr-plugin'
import '.cu{top:0px;}.ssr-plugin'
import '.bu{left:0px;}.ssr-plugin'
import '.bv{right:0px;}.ssr-plugin'
import '.gf{bottom:0px;}.ssr-plugin'
import '.ei{z-index:9999;}.ssr-plugin'
import '.gg{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.ck{justify-content:flex-end;}.ssr-plugin'
import '.c0{flex:1;}.ssr-plugin'
import '.af{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="by bz a0 bp b1 b2 ga"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="ct gb gc ae gd o ge a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a5 cu bu bv gf ei ae gg a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bz a ck ge"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c0 af">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
